<template>
  <div>
    <el-row>
      <el-col :span="14" :xs="24" class="div-center">
        <el-card>
          <div slot="header" class="clearfix">
            <span>Generate Seal Code</span>
          </div>
          <el-form label-width="80px" ref="form" :model="form" :label-position="labelPosition" @submit.native.prevent="submitForm">
            <h3>Step 1. Enter your Domain Name</h3>
            <el-form-item label="Domain">
               <el-input v-model="form.domain" auto-complete="off" maxlength="253" placeholder="google.com" :disabled="showCode"></el-input>
            </el-form-item>
            <h3>Step 2. Select Seal Size</h3>
            <div class="text-center margin-t30">
              <div class="margin-b10">
                <img src="https://seals.ssltrust.com.au/report_small.png" v-show="options.size === 'small'">
                <img src="https://seals.ssltrust.com.au/report_medium.png" v-show="options.size === 'medium'">
                <img src="https://seals.ssltrust.com.au/report_large.png" v-show="options.size === 'large'">
              </div>
              <el-radio-group v-model="options.size">
                <el-radio-button label="small">Small <small>( 125 x 26 )</small></el-radio-button>
                <el-radio-button label="medium">Medium <small>( 175 x 37 )</small></el-radio-button>
                <el-radio-button label="large">Large <small>( 250 x 53 )</small></el-radio-button>
              </el-radio-group>
            </div>
            <h3>Step 3. Terms and Conditions</h3>
              <ul>
                <li>The Seal can be placed on no more then 3 Pages of your website.</li>
                <li>You must place the site seal on the website under the domain name used on the report.</li>
                <li>The Seal may not be used in any way that will mislead visitors into believing that a web page or website is secure, when in fact it is not.</li>
              </ul>
              <div class="text-center">
               <el-checkbox v-model="form.agree">I Agree to the Terms and Conditions.</el-checkbox>
               </div>
            <h3>Step 4. Generate the Code</h3>
              <div class="text-center">
                <div v-html="error"></div>
                <el-button type="success" @click="generate" v-show="!showCode">Generate Seal Code</el-button>
                <el-button type="info" @click="reset" v-show="showCode">Reset</el-button>
              </div>

            <div v-show="showCode">
              <h3>Step 5. Place Code on your Website</h3>
              <p>Copy and Paste the below HTML code into your website html code to display the Seal and allow visitors to click it to view your Website Security Report.</p>
              <el-input
                type="textarea"
                :rows="5"
                :value="codeGen" >
              </el-input>
              <p class="padding-t30">If you don't want to use the provided Seal, you can link directly to the report with your own link or image using the below URL</p>
              <el-input
                type="text"
                :value="urlGen" >
              </el-input>
            </div>
          </el-form>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
  const isValidDomain = require('is-valid-domain')
  export default {
    data () {
      return {
        options: {
          size: 'medium',
        },
        form: {
          domain: '',
          agree: false
        },
        error: '',
        showCode: false
      }
    },
    methods: {
      generate () {
        this.error = ''
        // validate domain
        this.form.domain = this.form.domain.replace('http://', '').replace('https://', '')
        this.form.domain = this.form.domain.split('/')[0]
        if (this.form.domain === '' || !isValidDomain(this.form.domain) || this.form.domain.length > 253) {
          console.log('invalid')
          this.error = '<p class="text-danger">Valid Domain Name Required</p>'
        }
        if (this.form.agree !== true) {
          this.error += '<p class="text-danger">You must Agree to the Terms and Conditions</p>'
        }
        if (this.error) {
          return false
        }
        this.showCode = true
      },
      reset () {
        this.form.domain = ''
        this.form.agree = false
        this.showCode = false
      }
    },
    computed: {
      labelPosition: function () {
        return (window.innerWidth <= 800) ? 'top' : 'right'
      },
      codeGen: function () {
        return this.showCode ? '<a href="https://www.ssltrust.com.au/security-report?domain=' + this.form.domain + '" rel="nofollow" target="new"><img src="https://seals.ssltrust.com.au/report_' + this.options.size + '.png" style="border: 0px;"></a>' : ''
      },
      urlGen: function () {
        return this.showCode ? 'https://www.ssltrust.com.au/security-report?domain=' + this.form.domain : ''
      }
    }
  }
</script>
<style scoped lang="scss">
.div-center {
  margin: 0 auto;
  float: none;
}
</style>
